// extracted by mini-css-extract-plugin
export default {"container":"styles_container__oCukH","options":"styles_options__GZJjE","option":"styles_option__V8le8","option_icon":"styles_option_icon__yv-e0","heading":"styles_heading__6SeQl"};